import * as React from 'react';
import { styled } from '@mui/material/styles';
import Avatar from '@mui/material/Avatar';
import MuiDrawer, { drawerClasses } from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// import SelectContent from './SelectContent';
import MenuContent from './MenuContent';
import { Autocomplete, FormControl, FormHelperText, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import axios from 'axios';
import { useOrganizationSelect } from '../context/OrganizationSelectContext';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router';
import OptionsMenu from './OptionsMenu';


// import CardAlert from './CardAlert';
// import OptionsMenu from './OptionsMenu';

const drawerWidth = 270;

const Drawer = styled(MuiDrawer)({
  width: drawerWidth,
  flexShrink: 0,
  boxSizing: 'border-box',
  mt: 10,
  [`& .${drawerClasses.paper}`]: {
    width: drawerWidth,
    boxSizing: 'border-box',
  },
});

export default function SideMenu() {
   const [organizations, setOrganizations] = React.useState([]);
   const { user } = useAuth()
   const { selectedOrganization, setSelectedOrganization } = useOrganizationSelect();
   
   const getProfile = async () => {
     try {
       const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/auth/profile`, {
         headers: {
           Authorization: `Bearer ${localStorage.getItem('token')}`,
         },
       });
     } catch (error) {
       console.error('Error fetching profile:', error);
     }
   };




     const fetchOrganizations = async () => {
         try {
             const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/organizations/list`);
             setOrganizations(response.data.filter((org) => !org.deleted));
         } catch (error) {
             console.error('Error fetching organizations:', error);
         }
     };

    React.useEffect(() => {
      fetchOrganizations();
      getProfile();
    }, []);


  return (
    <Drawer
      variant="permanent"
      sx={{
        display: { xs: 'none', md: 'block' },
        [`& .${drawerClasses.paper}`]: {
          backgroundColor: 'background.paper',
        },
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          mt: 'calc(var(--template-frame-height, 0px) + 4px)',
          p: 1.5,
        }}
      >
      <Box
        component="img"
        sx={{
          width:'60%'
        }}
        alt="Omnibox Logo"
        src="/img/omnibox.png"
      />
      
        {/* <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Toolbox 
              </Typography> */}
            </Box>
            <Divider />
            <Box
             sx={{
              display: 'flex',
              mt: 'calc(var(--template-frame-height, 0px) + 4px)',
              p: 1.5,
            }}>
             {/* <FormControl fullWidth>
                <InputLabel>Client</InputLabel> */}
            {/* <Select
              autoWidth
              variant='outlined'
              value={selectedOrganization}
              label="Client"
              onChange={(e) => setSelectedOrganization(e.target.value)}
              size='small'
            > 
              <MenuItem key={0} value={""}>
                Tous les clients
              </MenuItem>
            {organizations.map((org) => (
              <MenuItem key={org._id} value={org.name}>
              {org.name}
              </MenuItem>
            ))}
            </Select> */}
            {/* </FormControl> */}
             <Autocomplete
      disablePortal
      size='small'
      fullWidth
      options={organizations}
      getOptionLabel={(option) => option.name}
      value={organizations.find((c) => c.name === selectedOrganization) || null}
      onChange={(_, newValue) => {
        setSelectedOrganization(newValue ? newValue.name : null);
      }}
      renderInput={(params) => <TextField {...params} label="Client" />}
      isOptionEqualToValue={(option, value) => option.name === value.name}
        />
        </Box>
        <Divider />
        <Box
        sx={{
          overflow: 'auto',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
        >
        
        <MenuContent />
      </Box>
      <Stack
        direction="row"
        sx={{
          p: 2,
          gap: 1,
          alignItems: 'center',
          borderTop: '1px solid',
          borderColor: 'divider',
        }}
      >
        <Avatar
          sizes="small"
          alt={`${user.firstname} ${user.lastname}`}
          src="/static/images/avatar/7.jpg"
          sx={{ width: 36, height: 36 }}
        >
          {user.firstname && user.lastname
        ? `${user.firstname[0]}${user.lastname[0]}`.toUpperCase()
        : ''}
        </Avatar>
        <Box sx={{ mr: 'auto' }}>
          <Typography variant="body2" sx={{ fontWeight: 500, lineHeight: '16px' }}>
        {user.firstname} {user.lastname} {console.log(user)}
          </Typography>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
        {user.email}
          </Typography>
        </Box>
        <OptionsMenu />
      </Stack>


    </Drawer>
  );
}